// Nombres de fantasía para los mp3 de utils/mp3/, indexados por fileName (no por key de S3).
// Agregar acá cada archivo nuevo que se suba al bucket; si falta, se usa un fallback automático.
export const MUSIC_TRACK_NAMES = {
  'blues.mp3': 'Blues',
  'corp1_backup.mp3': 'Slow',
  'corporate4.mp3': 'Tecnológico',
  'cyberpunk.mp3': 'Cinematográfico',
  'energetic.mp3': 'Enérgico',
  'free.mp3': 'Dub',
  'fresh.mp3': 'Fresh',
  'kugelsicher.mp3': 'Corporativo',
  'lastpoint.mp3': 'Bells',
  'showreel.mp3': 'Punk',
  'sweetlife.mp3': 'Dance',
};

const stripExtension = (fileName) => fileName.replace(/\.[^./]+$/, '');

const humanizeFileName = (fileName) =>
  stripExtension(fileName)
    .replace(/[_-]+/g, ' ')
    .trim()
    .replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());

export const getMusicTrackLabel = (fileName) => MUSIC_TRACK_NAMES[fileName] || humanizeFileName(fileName);
